import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface DownloadAuditCSVRequest {
  token: string;
  apiColumnFilters: any;
  apiSorting: any;
}

const downloadAuditCSV = async ({
  token,
  apiColumnFilters,
  apiSorting,
}: DownloadAuditCSVRequest) => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/download-audit-csv`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          columnFilters: apiColumnFilters,
          sorting: apiSorting,
        },
        responseType: "blob",
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default downloadAuditCSV;
